"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Command = void 0;
class Command {
    constructor(data) {
        this.data = data;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    toCommand() {
        return this.data;
    }
    toTaskFetchCommand() {
        return this.toTeamsDataCommand("task/fetch");
    }
    toInvokeCommand() {
        return this.toTeamsDataCommand("invoke");
    }
    toTeamsDataCommand(type) {
        return Object.assign(Object.assign({}, this.data), { msteams: {
                type,
            } });
    }
}
exports.Command = Command;
//# sourceMappingURL=Command.js.map